import "./css/app.scss";

import "./ts/neto.js";



import lazyLoad from "./ts/lazyLoad";
import loadSprite from "./ts/loadSprite";
import dropdown from "./ts/dropdowns";
import popup from "./ts/popups";
import tabs from "./ts/tabs";
import mobMenu from "./ts/mobMenu";
import slider from "./ts/slide";
import accordian from "./ts/accordian";
import readMore from "./ts/readmore";
import descMenu from "./ts/descMenu";
import stickyHeader from "./ts/stickyHeader";
import subCats from "./ts/subCategories";
import switchImg from "./ts/switchImg";
import pagination from "./ts/pagination";
import cartLine from "./ts/cartLine"
import multyBuy from "./ts/multyBuy";

loadSprite.init();
lazyLoad.init();
dropdown.init();
popup.init();
tabs.init();
mobMenu.init();
descMenu.init();
slider.init();
accordian.init();
readMore.init();
stickyHeader.init();
switchImg.init();
subCats.init();
pagination.init()
cartLine.init()
multyBuy.init()